import { graphql } from 'react-relay';

import { useMutationInterop } from '@confluence/apollo-relay-interop';

import type {
	useUpdateContentDirectRestrictionsMutation$data as MutationData,
	useUpdateContentDirectRestrictionsMutation$variables as MutationVariables,
} from './__generated__/useUpdateContentDirectRestrictionsMutation.graphql.ts';

// NOTE: This is the updated mutation shape requested for controller usage
export const updateContentDirectRestrictionsMutation = graphql`
	mutation useUpdateContentDirectRestrictionsMutation(
		$cloudId: ID!
		$input: ConfluenceUpdateContentDirectRestrictionsInput!
	) {
		confluence_updateContentDirectRestrictions(cloudId: $cloudId, input: $input) {
			success
			errors {
				message
			}
			contentDirectRestrictions {
				applied {
					added {
						edit {
							restrictions {
								principalId
								principalType
							}
							__typename
						}
						view {
							restrictions {
								principalId
								principalType
							}
							__typename
						}
					}
					removed {
						edit {
							restrictions {
								principalId
								principalType
							}
							__typename
						}
						view {
							restrictions {
								principalId
								principalType
							}
							__typename
						}
					}
				}
				confluencePermissionsSummary {
					limit
					remainingSlots
					totalCount
					totalGroups
					totalTeams
					totalUsers
					__typename
				}
			}
		}
	}
`;

export function useUpdateContentDirectRestrictions() {
	return useMutationInterop<MutationData, MutationVariables>(
		updateContentDirectRestrictionsMutation,
	);
}
